// this is an autogenerated file from DesignSystem/SendPatientSignatureRequestMessage/mutationSms.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_SendPatientSignatureRequestMessage($number: PhoneNumber!) {
  thread: comms_threads_sms_create(number: $number) {
    id
  }
}

`